<template>
  <!-- 轮播图 -->
  <div class="multi-box" v-if="tplId === '6' && status === 'running' && carItemList.length > 1">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide cars-itme" v-for="(item) in carItemList" :key="item.id">
          <img
            @click="carItemClick(item)"
            :class="['it-mg', atv == item.id ? 'it-mg-actv' : '']"
            :src="item.playPreviewImageFullUrl"
          >
          <span :class="['it-txt droidSerif', atv == item.id ? 'it-txt-actv droidSerif-bold' : 'it-txt-cz']">{{ item.name }}</span>
        </div>
      </div>
      <div v-if="carItemList.length > 4" class="swiper-prev" :style="{ background: `url(${left_icon})` }" @click.stop="handleSwiper('prev')"></div>
      <div v-if="carItemList.length > 4" class="swiper-next" :style="{ background: `url(${right_icon})` }" @click.stop="handleSwiper('next')"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { useNetwork } from '@vueuse/core'
import { useMessage } from 'naive-ui'
import { cloneDeep } from 'lodash-unified'
import { useStore } from '@gx-vuex'
import { getFileSuffix } from '@/utils/util'
import left_icon from '@/assets/extraIcon/left_icon.svg'
import right_icon from '@/assets/extraIcon/right_icon.svg'
import { useChat } from './useChat'
import { isBuild, typeViteEnv, isDev } from '@/utils/env'
import { isIOS } from '@vueuse/shared'

const { success } = useMessage()
const { isOnline, effectiveType } = useNetwork()

const { startChat, needSwitch } = useChat()

const carItemList = ref<{
  id: number;
  name: string;
  playPreviewImageFullUrl: string;
}[]>([])

try {
  // @ts-ignore
  carItemList.value = vLives
} catch (e) {

}

const store = useStore()
let livePlayer = ref()
const mySwiper = ref()
const firstPlay = ref(false)

let newVideo: any = null

let contentId = document.querySelector('body').getAttribute('data-id')

const tplId = ref(document.querySelector('body').getAttribute('data-tplId') as any)

const publicImageUrl = isBuild() ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image' : '/src/assets/image'

const atv = ref<Number>(0)

function dispose() {
  if (livePlayer.value) livePlayer.value?.destroy(true)
  livePlayer.value = null
}

const carItemClick = (record: any) => {    // 记录被点击的图片，加红色边框，下边文字高亮
  atv.value = record.id
  
  store.point.nameClick('change_vlive')
  
  if (livePlayer.value) {
    livePlayer.value?.pause()
    livePlayer.value.url = record.pullStreamUrl
  }
  
  success('Switching perspective, please wait...')
  
  store.global.setGlobalData({
    liveInfo: cloneDeep(record)
  })
  store.global.setGlobalData({
    liveId: record.id
  })
}

// xrpano播放器
function initVrPlayer(val: any) {
  const isLive = store.global.liveStatus === 'running'
  const param = {
    id: '#vr-player',
    showUI: false,
    crossOrigin: 'anonymous',
    autoplay: true,
    isLive,
    debug: false,
    show2D: false,
    ctx: {
      debug: false,
      isVR: true,
      type: '1'
    },
    src: val
  }
  // @ts-ignore
  newVideo = xrpano.createPlayer(param)
  
  if (livePlayer.value) {
    livePlayer.value.controls.add({
      name: 'vr-position',
      index: 11,
      position: 'right',
      html: `<img style="width: 20px;height: 20px;" src="${publicImageUrl}/vrIcon.svg" alt="vrIcon.svg">`,
      click: function () {
        newVideo.scene.backToInitialFov()
      }
    })
  }
}

const initPlayer = () => {
  if (isOnline.value) {
    try {
      // @ts-ignore
      if (slow === 0) {
        // @ts-ignore
        slow = 3
      }
      
      // @ts-ignore
      document.querySelector('#live-message').style.zIndex = -1
      document.querySelector('#live-message').innerHTML = ``
      
      // 寻常直播
      const firstLive: {
        recordUrl: string;
        pullStreamUrl: string;
        showPad: boolean;
        id: number;
        playPreviewImageFullUrl: string;
        // @ts-ignore
      } = vLives?.find(item => item.liveId == contentId)
      store.global.setGlobalData({
        liveInfo: cloneDeep(firstLive)
      })
      store.global.setGlobalData({
        liveId: firstLive.id
      })
      atv.value = firstLive.id
      
      const isLive = store.global.liveStatus === 'running'
      
      if (isLive || (store.global.liveStatus === 'end' && firstLive.recordUrl)) {
        // 直播、重播
        const url = isLive
          ? firstLive.pullStreamUrl || ''
          : firstLive.recordUrl
        if (getFileSuffix(url) == 'm3u8') {
          // @ts-ignore
          livePlayer.value = new Artplayer({
            id: 'vr-player',
            container: '#live-player',
            lang: 'en',
            isLive,
            url: isLive
              ? firstLive.pullStreamUrl || ''
              : firstLive.recordUrl,
            moreVideoAttr: {
              'webkit-playsinline': true,
              preload: 'preload',
              'x-webkit-airplay': 'true',
              playsInline: true
            },
            fullscreenWeb: true,
            icons: {
              play: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_puse.svg" alt="video_puse.svg">`,
              pause: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_play.svg" alt="video_play.svg">`,
              state: `<img style="width: 60px;height: 60px;" src="${publicImageUrl}/puse.svg" alt="puse.svg">`,
              volume: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSound.svg" alt="iconSound.svg">`,
              volumeClose: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSoundCLose.svg" alt="iconSoundCLose.svg">`,
              fullscreenWebOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
              fullscreenWebOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg"">`,
              fullscreenOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
              fullscreenOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`
            },
            customType: {
              m3u8: function playM3u8(video, url, art) {
                // @ts-ignore
                if (Hls.isSupported()) {
                  if (art.hls) art.hls.destroy()
                  // @ts-ignore
                  const hls = new Hls()
                  hls.loadSource(url)
                  hls.attachMedia(video)
                  art.hls = hls
                  // @ts-ignore
                  art.hls.on(Hls.Events.ERROR, (e, data) => {
                    if (data.fatal) {
                      store.point.videoError('error')
                      
                      dispose()
                      
                      // @ts-ignore
                      document.querySelector('#live-message').style.zIndex = 10
                      document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
                    }
                  })
                  art.on('destroy', () => hls.destroy())
                } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                  video.src = url
                } else {
                  art.notice.show = 'Unsupported playback format: m3u8'
                }
              }
            }
          })
        } else {
          // @ts-ignore
          livePlayer.value = new Artplayer({
            id: 'vr-player',
            container: '#live-player',
            lang: 'en',
            isLive,
            url: isLive
              ? firstLive.pullStreamUrl || ''
              : firstLive.recordUrl,
            moreVideoAttr: {
              'webkit-playsinline': true,
              preload: 'preload',
              'x-webkit-airplay': 'true',
              playsInline: true
            },
            fullscreenWeb: true,
            icons: {
              play: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_puse.svg" alt="video_puse.svg">`,
              pause: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_play.svg" alt="video_play.svg"">`,
              state: `<img style="width: 60px;height: 60px;" src="${publicImageUrl}/puse.svg" alt="puse.svg">`,
              volume: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSound.svg" alt="iconSound.svg">`,
              volumeClose: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSoundCLose.svg" alt="iconSoundCLose.svg">`,
              fullscreenWebOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
              fullscreenWebOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`,
              fullscreenOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
              fullscreenOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`
            }
          })
        }
      } else if (store.global.liveStatus === 'wait') {
        //预告
        // @ts-ignore
        if (live.previewType == 1 && live.previewFullUrl) {
          // 预告为video
          // @ts-ignore
          if (getFileSuffix(live.previewFullUrl) == 'm3u8') {
            // @ts-ignore
            livePlayer.value = new Artplayer({
              id: 'vr-player',
              container: '#live-player',
              lang: 'en',
              // @ts-ignore
              url: live.previewFullUrl,
              moreVideoAttr: {
                'webkit-playsinline': true,
                preload: 'preload',
                'x-webkit-airplay': 'true',
                playsInline: true
              },
              fullscreenWeb: true,
              icons: {
                play: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_puse.svg" alt="video_puse.svg">`,
                pause: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_play.svg" alt="video_play.svg">`,
                state: `<img style="width: 60px;height: 60px;" src="${publicImageUrl}/puse.svg" alt="puse.svg">`,
                volume: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSound.svg" alt="iconSound.svg">`,
                volumeClose: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSoundCLose.svg" alt="iconSoundCLose.svg">`,
                fullscreenWebOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
                fullscreenWebOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`,
                fullscreenOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
                fullscreenOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`
              },
              customType: {
                m3u8: function playM3u8(video, url, art) {
                  // @ts-ignore
                  if (Hls.isSupported()) {
                    if (art.hls) art.hls.destroy()
                    // @ts-ignore
                    const hls = new Hls()
                    hls.loadSource(url)
                    hls.attachMedia(video)
                    art.hls = hls
                    // @ts-ignore
                    art.hls.on(Hls.Events.ERROR, (e, data) => {
                      if (data.fatal) {
                        store.point.videoError('error')
                        
                        dispose()
                        
                        // @ts-ignore
                        document.querySelector('#live-message').style.zIndex = 10
                        document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
                      }
                    })
                    art.on('destroy', () => hls.destroy())
                  } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                    video.src = url
                  } else {
                    art.notice.show = 'Unsupported playback format: m3u8'
                  }
                }
              }
            })
          } else {
            // @ts-ignore
            livePlayer.value = new Artplayer({
              id: 'vr-player',
              container: '#live-player',
              lang: 'en',
              // @ts-ignore
              url: live.previewFullUrl,
              moreVideoAttr: {
                'webkit-playsinline': true,
                preload: 'preload',
                'x-webkit-airplay': 'true',
                playsInline: true
              },
              fullscreenWeb: true,
              icons: {
                play: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_puse.svg" alt="video_puse.svg">`,
                pause: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_play.svg" alt="video_play.svg">`,
                state: `<img style="width: 60px;height: 60px;" src="${publicImageUrl}/puse.svg" alt="puse.svg"">`,
                volume: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSound.svg" alt="iconSound.svg>`,
                volumeClose: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSoundCLose.svg" alt="iconSoundCLose.svg">`,
                fullscreenWebOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
                fullscreenWebOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`,
                fullscreenOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
                fullscreenOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`
              }
            })
          }
          // @ts-ignore
        } else if (live.previewFullUrl) {
          if (document.querySelector('.pd-image')) {
            document.querySelector('.pd-image')?.remove()
          }
          // 预告为img
          const el = document.createElement('img')
          el.setAttribute('class', 'pd-image')
          // @ts-ignore
          el.src = live.previewFullUrl
          document.getElementById('live-player').append(el)
        }
      }
      if (livePlayer.value) {
        const id = 'live-player'
        document.querySelector(`#${id} .art-video-player`).setAttribute('id', 'vr-player')
        if (isIOS) {
          setTimeout(() => {
            livePlayer.value.loading.show = false
          }, 100)
        }
        // @ts-ignore
        if (live.vr) {
          initVrPlayer(document.querySelector(`#${id} video`))
        }
        
        livePlayer.value.on('play', () => {
          if (!firstPlay.value) {
            firstPlay.value = true
            store.point.videoPlay({
              duration: livePlayer.value.duration
            })
          }
        })
        
        livePlayer.value.on('video:ended', () => {
          store.point.videoEnd({
            currentTime: livePlayer.value.currentTime,
            duration: livePlayer.value.duration
          })
        })
        
        livePlayer.value.on('error', (e) => {
          store.point.videoError(e.type)
          
          // dispose()
          //
          // // @ts-ignore
          // document.querySelector('#live-message').style.zIndex = 10
          // document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
        })
        
        livePlayer.value.on('fullscreenWeb', (state) => {
          store.point.nameClick('full_screen_click')
          if (state) {
            const el = document.querySelector('.live-player .live-player-title').cloneNode(true)
            document.getElementById('vr-player').append(el)
            // @ts-ignore
            document.querySelector('#vr-player .live-player-title').style.display = 'block'
          } else {
            document.querySelector('#vr-player .live-player-title')?.remove()
          }
        })
      }
    } catch (e) {
      console.log(e)
    }
  } else {
    dispose()
    
    // @ts-ignore
    document.querySelector('#live-message').style.zIndex = 10
    document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
  }
}

const initDevPlayer = () => {
  const liveDetails = store.global.details?.liveInfo
  
  const liveDataStore = liveDetails.vlive?.map((item, index) => {
    if (index === 0) item.active = true
    
    return item
  })
  
  const isLive = liveDetails?.status === 'running'
  const firstLive = liveDataStore?.find(item => item.active)
  
  const hasRecordLive = firstLive.replayUri && liveDetails?.status === 'end'
  
  // 直播、重播
  let url = isLive
    ? firstLive?.liveUrl || ''
    : hasRecordLive ? firstLive?.replayUri : ''
  
  if (
    liveDetails?.status === 'wait' &&
    liveDetails?.previewType === 1 &&
    liveDetails?.previewUrl
  ) {
    url = liveDetails?.previewUrl
  }
  
  
  if (url) {
    // @ts-ignore
    livePlayer.value = new Artplayer({
      id: 'vr-player',
      container: '#livePlayer',
      lang: 'en',
      isLive,
      url,
      moreVideoAttr: {
        'webkit-playsinline': true,
        preload: 'preload',
        'x-webkit-airplay': 'true',
        playsInline: true
      },
      fullscreenWeb: true,
      icons: {
        play: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_puse.svg" alt="video_puse.svg">`,
        pause: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/player/video_play.svg" alt="/video_play.svg">`,
        state: `<img style="width: 60px;height: 60px;" src="${publicImageUrl}/puse.svg" alt="puse.svg">`,
        volume: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSound.svg" alt="iconSound.svg">`,
        volumeClose: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconSoundCLose.svg" alt="iconSoundCLose.svg">`,
        fullscreenWebOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="iconFullScreen.svg">`,
        fullscreenWebOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg"">`,
        fullscreenOn: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconFullScreen.svg" alt="conFullScreen.svg">`,
        fullscreenOff: `<img style="width: 22px;height: 22px;" src="${publicImageUrl}/iconExFullScreen.svg" alt="iconExFullScreen.svg">`
      },
      customType: getFileSuffix(url) == 'm3u8' ? {
        m3u8: function playM3u8(video: any, url: any, art: any) {
          // @ts-ignore
          if (Hls.isSupported()) {
            if (art.hls) art.hls.destroy()
            // @ts-ignore
            const hls = new Hls()
            hls.loadSource(url)
            hls.attachMedia(video)
            art.hls = hls
            // @ts-ignore
            art.hls.on(Hls.Events.ERROR, (e, data) => {
              if (data.fatal) {
                store.point.videoError('error')
                
                dispose()
                
                // @ts-ignore
                document.querySelector('#live-message').style.zIndex = 10
                document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
              }
            })
            art.on('destroy', () => hls.destroy())
          } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = url
          } else {
            art.notice.show = 'Unsupported playback format: m3u8'
          }
        }
      } : {}
    })
  }  else if (liveDetails.previewUrl) {
    if (document.querySelector('.pd-image')) {
      document.querySelector('.pd-image')?.remove()
    }
    // 预告为img
    const el = document.createElement('img')
    el.setAttribute('class', 'pd-image')
    // @ts-ignore
    el.src = liveDetails.previewUrl
    document.getElementById('live-player').append(el)
  }
  
  if (livePlayer.value) {
    const id = 'live-player'
    document.querySelector(`#${id} .art-video-player`).setAttribute('id', 'vr-player')
    if (isIOS) {
      setTimeout(() => {
        livePlayer.value.loading.show = false
      }, 100)
    }
    // @ts-ignore
    if (live.vr) {
      initVrPlayer(document.querySelector(`#${id} video`))
    }
    
    livePlayer.value.on('restart', () => {
      livePlayer.value?.play()
    })
    
    livePlayer.value.on('play', () => {
      if (!firstPlay.value) {
        firstPlay.value = true
        store.point.videoPlay({
          duration: livePlayer.value.duration
        })
      }
    })
    
    livePlayer.value.on('video:ended', () => {
      store.point.videoEnd({
        currentTime: livePlayer.value.currentTime,
        duration: livePlayer.value.duration
      })
    })
    
    livePlayer.value.on('error', (e) => {
      store.point.videoError(e.type)
      
      dispose()
      
      // @ts-ignore
      document.querySelector('#live-message').style.zIndex = 10
      document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
    })
    
    livePlayer.value.on('fullscreenWeb', (state) => {
      store.point.nameClick('full_screen_click')
      if (state) {
        const el = document.querySelector('.live-player .live-player-title').cloneNode(true)
        document.getElementById('vr-player').append(el)
        // @ts-ignore
        document.querySelector('#vr-player .live-player-title').style.display = 'block'
      } else {
        document.querySelector('#vr-player .live-player-title')?.remove()
      }
    })
  }
}

watch(() => effectiveType.value, (val) => {
  if (val === '2g') {
    dispose()
    
    // @ts-ignore
    document.querySelector('#live-message').style.zIndex = 10
    document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
  } else {
    if (livePlayer.value) livePlayer.value?.destroy(true)
    initPlayer()
  }
})

watch(() => isOnline.value, (val) => {
  if (!val) {
    dispose()
    
    // @ts-ignore
    document.querySelector('#live-message').style.zIndex = 10
    document.querySelector('#live-message').innerHTML = `<span>Please check your network connection and <a href="${location.href}">try again!</a></span>`
  } else {
    if (livePlayer.value) livePlayer.value?.destroy(true)
    initPlayer()
  }
})

watch(() => needSwitch.value, (val) => {
  if (val) {
    dispose()
    if (document.querySelector('.pd-image')) {
      document.querySelector('.pd-image')?.remove()
    }
    const el = document.createElement('img')
    el.setAttribute('class', 'pd-image')
    // @ts-ignore
    el.src = live.padImageFullUrl
    document.getElementById('live-player').append(el)
  } else {
    if (livePlayer.value) livePlayer.value?.destroy(true)
    if (document.querySelector('.pd-image')) {
      document.querySelector('.pd-image')?.remove()
    }
    initPlayer()
  }
}, { deep: true })

function initLive() {
  let firstLive: Partial<{
    recordUrl: string;
    pullStreamUrl: string;
    showPad: boolean;
    id: number;
    playPreviewImageFullUrl: string;
    // @ts-ignore
  }> = {}
  try {
    // @ts-ignore
    firstLive = vLives?.find(item => item.liveId == contentId)
    
    // 寻常直播
    
    startChat()
    if (livePlayer.value) livePlayer.value?.destroy(true)
    if (firstLive.showPad) {
      if (document.querySelector('.pd-image')) {
        document.querySelector('.pd-image')?.remove()
      }
      const el = document.createElement('img')
      el.setAttribute('class', 'pd-image')
      // @ts-ignore
      el.src = live.padImageFullUrl
      document.getElementById('live-player').append(el)
      
      try {
        // @ts-ignore
        if (slow === 0) {
          // @ts-ignore
          slow = 3
        }
        // @ts-ignore
        document.querySelector('#live-message').style.zIndex = -1
        document.querySelector('#live-message').innerHTML = ``
      } catch (e) {
      
      }
    } else {
      initPlayer()
    }
    // @ts-ignore
    mySwiper.value = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 16
    })
    
    window.addEventListener('beforeunload', function () {
      if (livePlayer.value) {
        store.point.videoEnd({
          currentTime: livePlayer.value.currentTime,
          duration: livePlayer.value.duration
        })
      }
    })
  } catch (e) {
  }
}

onMounted(() => {
  initLive()
})

watch(() => store.global.initContentState, (val) => {
  if (isDev() && val === 1) {
    try {
      // @ts-ignore
      if (slow === 0) {
        // @ts-ignore
        slow = 3
      }
      // @ts-ignore
      document.querySelector('#live-message').style.zIndex = -1
      document.querySelector('#live-message').innerHTML = ``
      
      const liveInfo = store.global.details?.liveInfo
      
      if (liveInfo) {
        store.global.setGlobalData({
          liveStatus: liveInfo.liveState
        })
        tplId.value = liveInfo.tplId
        contentId = store.global.details.newsId
        
        const liveDetails = store.global.details?.liveInfo
        
        const liveDataStore = liveDetails.vlive?.map((item, index) => {
          if (index === 0) item.active = true
          
          return item
        })
        
        const firstLive = liveDataStore?.find(item => item.active)
        
        if (firstLive.showPad) {
          if (document.querySelector('.pd-image')) {
            document.querySelector('.pd-image')?.remove()
          }
          const el = document.createElement('img')
          el.setAttribute('class', 'pd-image')
          // @ts-ignore
          el.src = liveDetails.padImageUri
          document.getElementById('live-player').append(el)
          
          try {
            // @ts-ignore
            if (slow === 0) {
              // @ts-ignore
              slow = 3
            }
            // @ts-ignore
            document.querySelector('#live-message').style.zIndex = -1
            document.querySelector('#live-message').innerHTML = ``
          } catch (e) {
          
          }
        } else {
          initDevPlayer()
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
})

const handleSwiper = (type: string) => {
  if (type === 'prev')
    mySwiper.value.slidePrev()
  else
    mySwiper.value.slideNext()
  
}
</script>

<style lang="less" scoped>
.cars-itme {
  width: 160px;
  height: 122px;
  
  img {
    display: block;
  }
  
  .it-mg {
    display: inline-block;
    width: 160px;
    height: 86px;
    cursor: pointer;
    border: 2px solid transparent;
    
    &.it-mg-actv {
      border-color: #e13739;
    }
  }
  
  .it-txt-actv {
    color: #fff;
  }
  
  .it-txt-cz {
    color: rgba(255, 255, 255, 0.7);
  }
  
  .it-txt {
    font-size: 14px;
    font-family: Droid Serif-Regular, Droid Serif;
    font-weight: 400;
  }
}

.multi-box {
  width: 848px;
  height: 122px;
  position: relative;
  overflow: hidden;
  
  .swiper-prev, .swiper-next {
    cursor: pointer;
    position: absolute;
    width: 24px;
    height: 28px;
  }
  
  .swiper-prev {
    left: 0;
    z-index: 10;
    top: 31px;
  }
  
  .swiper-next {
    z-index: 10;
    right: 0;
    top: 31px;
  }
  
  .dots-lt {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -24px);
    z-index: 232323;
  }
  
  .dots-rt {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -24px);
    margin-right: 8px;
    z-index: 232323;
  }
  
}
</style>
